"use strict";
/*
 * Created on 09 02 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var index_1 = require("../../core/utils/index");

var PriceWithValidityConverter_1 = require("../../product/conversions/PriceWithValidityConverter");

var ProductPurchasePriceConverter_1 = require("../../product/conversions/ProductPurchasePriceConverter");

var ZonePricesConverter_1 = require("../../product/conversions/ZonePricesConverter");

var SiteReleaseItem_1 = require("../model/SiteReleaseItem");

var SiteReleaseItemConverter_1 = require("./SiteReleaseItemConverter");
/**
 * <p>Implementation of {@link SiteReleaseItemConverter}.</p>
 *
 * @author Jaroslav Sevcik
 * @author JMe
 */


var SiteReleaseItemConverterImpl =
/*#__PURE__*/
function (_SiteReleaseItemConve) {
  _inherits(SiteReleaseItemConverterImpl, _SiteReleaseItemConve);

  function SiteReleaseItemConverterImpl(priceWithValidityConverter, purchasePriceConverter, zonePricesConverter, validationResultConverter) {
    var _this;

    _classCallCheck(this, SiteReleaseItemConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseItemConverterImpl).call(this));
    _this.priceWithValidityConverter = priceWithValidityConverter;
    _this.purchasePriceConverter = purchasePriceConverter;
    _this.zonePricesConverter = zonePricesConverter;
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SiteReleaseItemConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        productId: conversions.toDocumentReferenceId(source.productId),
        productExternalId: source.productExternalId,
        productName: source.productName,
        siteId: conversions.toDocumentReferenceId(source.siteId),
        siteExtId: source.siteExtId,
        siteName: source.siteName,
        exported: source.exported,
        exportedDate: conversions.asObjectOpt(source, 'exportedDate', function (v) {
          return conversions.fromDate(v);
        }),
        price: conversions.asObject(source, 'price', function (v) {
          return _this2.priceWithValidityConverter.toDocument(v, conversions);
        }),
        tierId: conversions.toDocumentReferenceId(source.tierId),
        productSensitivityId: conversions.toDocumentReferenceId(source.productSensitivityId),
        supplierId: conversions.asObjectOpt(source, 'supplierId', function (v) {
          return conversions.toDocumentReferenceId(v);
        }),
        familyId: conversions.asObjectOpt(source, 'familyId', function (v) {
          return conversions.toDocumentReferenceId(v);
        }),
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        purchasePrice: conversions.asObjectOpt(source, 'purchasePrice', function (obj) {
          return _this2.purchasePriceConverter.toDocument(obj, conversions);
        }),
        zonePrices: conversions.asObjectArray(source, 'zonePrices', function (v) {
          return _this2.zonePricesConverter.toDocument(v, conversions);
        }),
        validation: this.validationResultConverter.toDocument(source.validation, conversions)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this3 = this;

      return new SiteReleaseItem_1.SiteReleaseItem(conversions.documentToClassId(source), conversions.asObject(source, 'releaseId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'productId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'productExternalId', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObject(source, 'productName', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObject(source, 'siteId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'siteExtId', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObject(source, 'siteName', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObject(source, 'exported', function (v) {
        return index_1.Utils.asBool(v);
      }), conversions.asObjectOpt(source, 'exportedDate', function (v) {
        return conversions.toDate(v);
      }), conversions.asObject(source, 'price', function (v) {
        return _this3.priceWithValidityConverter.toObject(v, conversions);
      }), conversions.asObject(source, 'tierId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'productSensitivityId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'supplierId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'familyId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectList(source, 'categoryIds', function (id) {
        return conversions.toClassReferenceId(id);
      }), conversions.asObjectOpt(source, 'purchasePrice', function (doc) {
        return _this3.purchasePriceConverter.toObject(doc, conversions);
      }), conversions.asObjectList(source, 'zonePrices', function (v) {
        return _this3.zonePricesConverter.toObject(v, conversions);
      }), conversions.asObject(source, 'validation', function (doc) {
        return _this3.validationResultConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return SiteReleaseItemConverterImpl;
}(SiteReleaseItemConverter_1.SiteReleaseItemConverter);

SiteReleaseItemConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __metadata("design:paramtypes", [PriceWithValidityConverter_1.PriceWithValidityConverter, ProductPurchasePriceConverter_1.ProductPurchasePriceConverter, ZonePricesConverter_1.ZonePricesConverter, ValidationResultConverter_1.ValidationResultConverter])], SiteReleaseItemConverterImpl);
exports.SiteReleaseItemConverterImpl = SiteReleaseItemConverterImpl;